var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Color from 'color';
import { observer } from 'mobx-react';
import React from 'react';
import { SwatchesPicker } from 'react-color';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardBody, CardFooter, Col, Container, Form, Input, Row } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import CreateManualAssetCommand from '../../../commands/assets/CreateManualAssetCommand';
import GetOrganisationAssetsCommand from '../../../commands/assets/GetOrganisationAssetsCommand';
import { FormErrorContext } from '../../../FormErrorContext';
import InitialManualAssetModel from '../../../models/InitialManualAssetModel';
import Signals from '../../../signals/Signals';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import { parseFloatToDecimals } from '../../../utils/numberUtils';
import BasicFormGroup from '../../components/ui/BasicFormGroup/BasicFormGroup';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import DateInput from '../../components/ui/DateInput/DateInput';
import { EmissionClassSelector } from "../../components/ui/EmissionClassSelector";
import { FuelTypeSelector } from "../../components/ui/FuelTypeSelector";
import IconSelector from '../../components/ui/IconSelector/IconSelector';
import LocationPicker from '../../components/ui/LocationPicker/LocationPicker';
/**
 *
 */
var CreateManualAssetOverlay = /** @class */ (function (_super) {
    __extends(CreateManualAssetOverlay, _super);
    /**
     *
     * @param props
     */
    function CreateManualAssetOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: {},
            submitting: false,
            initialManualAssetModel: new InitialManualAssetModel(),
            statusDate: null,
            iconColor: new Color([0, 0, 0, 255]),
            displayColorPicker: false,
            dateRequired: false,
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onIconSelect = _this.onIconSelect.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onStatusDateChange = _this.onStatusDateChange.bind(_this);
        _this.onLocationChange = _this.onLocationChange.bind(_this);
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    CreateManualAssetOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    CreateManualAssetOverlay.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, intl = _a.intl;
        var _b = this.state, errors = _b.errors, statusDate = _b.statusDate, iconColor = _b.iconColor, selectedIconName = _b.selectedIconName, displayColorPicker = _b.displayColorPicker, dateRequired = _b.dateRequired;
        return React.createElement(Container, { className: 'create-manual-asset-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'manual.asset.create.overlay.title' }) }),
                        React.createElement(CardBody, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { md: 6 },
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.serialnumber' }), htmlFor: "serialNumber", classNamesForFormField: "position-relative" },
                                        React.createElement(Input, { type: "text", id: "serialNumber", name: "serialNumber", required: true }),
                                        React.createElement("span", { className: "small text-muted position-absolute", style: { top: '100%', left: 0 } }, intl.formatMessage({ id: 'manual.asset.create.overlay.field.serialnumber.notice' }))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.equipmentid' }), htmlFor: "equipmentId" },
                                        React.createElement(Input, { type: "text", id: "equipmentId", name: "equipmentId", required: true })),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.make' }), htmlFor: "make" },
                                        React.createElement(Input, { type: "text", id: "make", name: "make", required: true })),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.model' }), htmlFor: "model" },
                                        React.createElement(Input, { type: "text", id: "model", name: "model", required: true })),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.emissionClass' }), htmlFor: "emissionClass" },
                                        React.createElement("div", { className: "input-group" },
                                            React.createElement(EmissionClassSelector, { value: this.state.initialManualAssetModel.emissionClass, onChange: function (value) {
                                                    _this.state.initialManualAssetModel.emissionClass = value;
                                                }, id: "emissionClass", name: "emissionClass", className: "w-100" }))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.nominalPower' }), htmlFor: "nominalPower" },
                                        React.createElement("div", { className: "input-group" },
                                            React.createElement(Input, { type: "number", min: 0.1, max: 10000, step: 0.1, id: "nominalPower", name: "nominalPower", onChange: this.onInputChange }))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.fuelType' }), htmlFor: "fuelType" },
                                        React.createElement("div", { className: "input-group" },
                                            React.createElement(FuelTypeSelector, { value: this.state.initialManualAssetModel.fuelType, onChange: function (value) {
                                                    _this.state.initialManualAssetModel.fuelType = value;
                                                }, id: "fuelType", name: "fuelType", className: "w-100" }))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.color' }), htmlFor: 'color' },
                                        React.createElement(Input, { id: "color", className: 'form-control form-control-append', name: "color", type: "text", style: {
                                                cursor: 'pointer',
                                                backgroundColor: iconColor,
                                                color: iconColor
                                            }, onFocus: function () {
                                                _this.setState({ displayColorPicker: !displayColorPicker });
                                            }, readOnly: true }),
                                        displayColorPicker &&
                                            React.createElement("div", { className: 'position-absolute', style: { zIndex: 1000 } },
                                                React.createElement(SwatchesPicker, { color: iconColor.hex(), onChange: this.onColorChange }))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.icons' }), htmlFor: 'icon', classNamesForFormField: "flex-nowrap overflow-auto py-1" },
                                        React.createElement(IconSelector, { onSelect: this.onIconSelect, color: iconColor, selectedIconName: selectedIconName }))),
                                React.createElement(Col, { md: 6 },
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.statusdate' }), htmlFor: "statusDate" },
                                        React.createElement("div", { className: "input-group" },
                                            React.createElement(DateInput, { intl: intl, name: "statusDate", id: "statusDate", className: "w-100", onBlur: this.onStatusDateChange, onChange: this.onStatusDateChange, value: statusDate ? statusDate : null, openToDate: statusDate, showTimeSelect: true, disableManualInput: true, required: dateRequired, disabled: !dateRequired, dateFormat: 'dd-MM-yyyy HH:mm' }),
                                            React.createElement("div", { className: "input-group-append" },
                                                React.createElement("span", { className: "input-group-text" },
                                                    React.createElement("i", { className: "fe fe-calendar" }))))),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.operatinghours' }), htmlFor: "initialCumulativeOperatingHoursValue" },
                                        React.createElement(Input, { type: "number", min: 0, step: 0.1, id: "initialCumulativeOperatingHoursValue", name: "initialCumulativeOperatingHoursValue", placeholder: intl.formatMessage({ id: 'manual.asset.create.overlay.no.update' }) })),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.fuelusage' }), htmlFor: "initialFuelUsedInLiters" },
                                        React.createElement(Input, { type: "number", min: 0, step: 0.1, id: "initialFuelUsedInLiters", name: "initialFuelUsedInLiters", placeholder: intl.formatMessage({ id: 'manual.asset.create.overlay.no.update' }) })),
                                    React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.location' }), htmlFor: "location" },
                                        React.createElement(LocationPicker, { onPositionChange: this.onLocationChange, showLastKnownLocation: false }))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     * Override setState to calculate derived state values
     */
    CreateManualAssetOverlay.prototype.setState = function (state, callback) {
        var _a, _b, _c, _d, _e, _f;
        var newState = __assign(__assign({}, this.state), state);
        var isStatusDateRequired = newState.lat != null
            || newState.lon != null
            || (((_b = (_a = newState.initialManualAssetModel) === null || _a === void 0 ? void 0 : _a.initialFuelUsedInLiters) === null || _b === void 0 ? void 0 : _b.value) != null)
            || (((_d = (_c = newState.initialManualAssetModel) === null || _c === void 0 ? void 0 : _c.initialCumulativeOperatingHoursValue) === null || _d === void 0 ? void 0 : _d.value) != null);
        var finalState = __assign(__assign({}, state), { dateRequired: isStatusDateRequired, statusDate: isStatusDateRequired ? ((_f = (_e = state.statusDate) !== null && _e !== void 0 ? _e : this.state.statusDate) !== null && _f !== void 0 ? _f : new Date()) : null });
        _super.prototype.setState.call(this, finalState, callback);
    };
    /**
     *
     * @param color
     * @param event
     */
    CreateManualAssetOverlay.prototype.onColorChange = function (color, event) {
        var initialManualAssetModel = this.state.initialManualAssetModel;
        this.setState({ iconColor: new Color(color.hex), displayColorPicker: false });
    };
    /**
     *
     * @param selectedIconName
     */
    CreateManualAssetOverlay.prototype.onIconSelect = function (selectedIconName) {
        var initialManualAssetModel = this.state.initialManualAssetModel;
        this.setState({ selectedIconName: selectedIconName });
    };
    /**
     *
     * @param event
     */
    CreateManualAssetOverlay.prototype.onInputChange = function (event) {
        var initialManualAssetModel = this.state.initialManualAssetModel;
        switch (event.target.name) {
            case 'statusDate':
                break;
            case 'initialFuelUsedInLiters':
                initialManualAssetModel.initialFuelUsedInLiters.value = event.target.value !== ""
                    ? parseFloatToDecimals(event.target.value, 1)
                    : null;
                this.setState({ initialManualAssetModel: initialManualAssetModel });
                break;
            case 'initialCumulativeOperatingHoursValue':
                initialManualAssetModel.initialCumulativeOperatingHoursValue.value = event.target.value !== ""
                    ? parseFloatToDecimals(event.target.value, 1)
                    : null;
                this.setState({ initialManualAssetModel: initialManualAssetModel });
                break;
            case 'nominalPower':
                var nominalPower = parseFloat(event.target.value);
                initialManualAssetModel[event.target.name] = isNaN(nominalPower) ? null : nominalPower;
                break;
            default:
                initialManualAssetModel[event.target.name] = event.target.value;
        }
    };
    /**
     *
     * @param lat
     * @param lon
     */
    CreateManualAssetOverlay.prototype.onLocationChange = function (lat, lon) {
        this.setState({ lat: lat, lon: lon });
    };
    /**
     *
     * @param event
     */
    CreateManualAssetOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, initialManualAssetModel = _a.initialManualAssetModel, statusDate = _a.statusDate, lat = _a.lat, lon = _a.lon, iconColor = _a.iconColor, selectedIconName = _a.selectedIconName, dateRequired = _a.dateRequired;
        var timestamp = dateRequired && statusDate ? statusDate.getTime() : null;
        initialManualAssetModel.initialLocation.latitude = lat;
        initialManualAssetModel.initialLocation.longitude = lon;
        initialManualAssetModel.initialLocation.timestamp = timestamp;
        initialManualAssetModel.initialCumulativeOperatingHoursValue.timestamp = timestamp;
        initialManualAssetModel.initialFuelUsedInLiters.timestamp = timestamp;
        initialManualAssetModel.iconName = selectedIconName;
        initialManualAssetModel.iconColor = iconColor;
        initialManualAssetModel.iconColorRgba = initialManualAssetModel.iconColor.rgbNumber();
        var command = new CreateManualAssetCommand();
        command.execute(initialManualAssetModel, session.user.organisation.id, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    CreateManualAssetOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    CreateManualAssetOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        Signals.HideAssetDetail.dispatch();
        // Refresh assets
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var intl = this.props.intl;
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        // No need for a .then() since the observer will pick up the changes in the asset collection
        command.execute(user.organisation, assetCollection).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
    };
    /**
     *
     * @param error
     */
    CreateManualAssetOverlay.prototype.onError = function (error) {
        if (error.response.status === 409
            && error.response.body.title === "Asset Already Exists") {
            var errors = {
                serialNumber: [this.props.intl.formatMessage({ id: 'error.Invalid.AssetDataAlreadyExistsForSerialNumber' })]
            };
            this.setState({ errors: errors, submitting: false });
        }
        else {
            console.log("ERROOOORRR", JSON.stringify(error));
            createErrorResponse(this, error);
        }
    };
    /**
     *
     * @param e
     * @param date
     */
    CreateManualAssetOverlay.prototype.onStatusDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            // The date input has no ms precision therefore entering the same date twice can result in a different timestamp
            // So set ms to 0 explicitly
            date.setMilliseconds(0);
            this.setState({ statusDate: date });
            var initialManualAssetModel = this.state.initialManualAssetModel;
            initialManualAssetModel.initialFuelUsedInLiters.timestamp = date.getTime();
            initialManualAssetModel.initialCumulativeOperatingHoursValue.timestamp = date.getTime();
            initialManualAssetModel.initialLocation.timestamp = date.getTime();
        }
    };
    CreateManualAssetOverlay.defaultProps = {
        className: ''
    };
    CreateManualAssetOverlay = __decorate([
        observer
    ], CreateManualAssetOverlay);
    return CreateManualAssetOverlay;
}(React.Component));
CreateManualAssetOverlay.contextType = ApplicationContext;
export default injectIntl(CreateManualAssetOverlay);
